<template>
  <button type="button" class="border-blue-300 border rounded text-white" @click="showMobileMenu"><action-icons icon="menu" class="inline" /></button>
</template>
<script>
import { globalEventBus } from '@root/_globalEventBus';
export default {
  name: 'main-nav-mobile-button',
  methods: {
    showMobileMenu() {
      globalEventBus.$emit('mobileMenuClicked');
    }
  },
}
</script>